// extracted by mini-css-extract-plugin
export default {"price":"e7-z","priceRow":"f7-z","onSale":"g7-z","msrpLabelPrice":"h7-z","msrpLabel":"i7-z","originalPrice":"j7-z","percentOff":"k7-z"};